<div class="my-personal-data">
  <div class="my-personal-data-content">
    <form [formGroup]="editForm">
      <div class="profile-data-group">
        <div class="title">{{ 'module.userProfile.myPersonalData.accessDataTitleText' | translate }}</div>
        <div *ngIf="isKam" class="photo-section">
          <div class="pic" (click)="imageCtrl.click()">
            <span *ngIf="!imageSrc" class="fa fa-user"></span>
            <img (load)="onImageLoad($event)" *ngIf="imageSrc" [ngClass]="['image', orientation]" [src]="imageSrc" alt="your image" />
            <input ng2FileSelect #imageCtrl [uploader]="imageUploader" type="file" name="file" id="file" class="inputfile" accept="image/*" />
            <label class="file-label" for="file" (click)="$event.stopPropagation()"
              ><span class="fa fa-camera"></span> {{ 'module.userProfile.myPersonalData.editPhotoLabelText' | translate }}</label
            >
            <div class="imageLoading" *ngIf="isImageLoading">
              <span class="fa fa-spinner fa-spin fa-3x"></span>
            </div>
          </div>
          <div class="error-text-picture" *ngIf="errorMmessagePic">{{ 'module.userProfile.myPersonalData.errorMessageTextPic' | translate }}</div>
          <div class="pic-notif">
            {{ 'module.userProfile.myPersonalData.recommendText' | translate }}
          </div>
        </div>

        <div class="profile-data-line">
          <p class="label"><span *ngIf="isEdit && isCIAM()" class="red">*</span> {{ 'module.userProfile.myPersonalData.firstNameLabelText' | translate }}</p>
          <div class="detail">
            <p *ngIf="!isEdit || (isEdit && !isCIAM())" class="detail detail-color">{{ user?.firstname }}</p>
            <input *ngIf="isEdit && isCIAM()" type="text" class="detail input" placeholder="Erforderliches Feld" formControlName="firstname" />
            <span *ngIf="isEdit && this.editForm.controls.firstname.invalid && isCIAM()" class="error-message">{{
              'module.userProfile.myPersonalData.onlyContainLettersSpanText' | translate
            }}</span>
          </div>
        </div>

        <div class="profile-data-line">
          <p class="label"><span *ngIf="isEdit && isCIAM()" class="red">*</span> {{ 'module.userProfile.myPersonalData.surnameSpanText' | translate }}</p>
          <div class="detail">
            <p *ngIf="!isEdit || (isEdit && !isCIAM())" class="detail detail-color">{{ user?.lastname }}</p>
            <input *ngIf="isEdit && isCIAM()" type="text" class="detail input" placeholder="Erforderliches Feld" formControlName="lastname" />
            <span *ngIf="isEdit && this.editForm.controls.lastname.invalid && isCIAM()" class="error-message">{{
              'module.userProfile.myPersonalData.onlyContainLettersSpanText' | translate
            }}</span>
          </div>
        </div>

        <div class="profile-data-line">
          <p class="label">{{ 'module.userProfile.myPersonalData.emailAddressLabelText' | translate }}</p>
          <p class="detail detail-color">{{ user?.email }}</p>
        </div>

        <div class="profile-data-line">
          <p class="label">{{ 'module.userProfile.myPersonalData.roleLabelText' | translate }}</p>
          <p class="detail detail-color">{{ roleName }}</p>
        </div>

        <div class="profile-data-line">
          <p class="label">{{ 'module.userProfile.myPersonalData.PrivilegeAccessText' | translate }}</p>
          <p class="detail detail-color">{{ user?.isPriviledgedAccess }}</p>
        </div>
      </div>

      <div class="profile-data-group">
        <div class="title">{{ 'module.userProfile.myPersonalData.contactTitleText' | translate }}</div>

        <div class="profile-data-line">
          <p class="label"><span *ngIf="isEdit" class="red">*</span> {{ 'module.userProfile.myPersonalData.telephoneNumberLabelText' | translate }}</p>
          <div class="detail">
            <p *ngIf="!isEdit" class="detail detail-color">{{ user?.telefon }}</p>
            <input
              *ngIf="isEdit"
              type="text"
              class="input detail"
              placeholder="{{ 'module.userProfile.myPersonalData.telephoneFieldTextPlaceholder' | translate }}"
              formControlName="telefon"
              maxlength="20"
              (input)="removeUserInputSpaces('telefon')"
            />
            <span *ngIf="isEdit && this.editForm.controls.telefon.invalid" class="error-message">{{
              'module.userProfile.myPersonalData.numbersAndHyphensOnlyText' | translate
            }}</span>
          </div>
        </div>
        <div class="class profile-data-line">
          <p class="label">{{ 'module.userProfile.myPersonalData.mobileNumberLabelText' | translate }}</p>
          <div class="detail">
            <p *ngIf="!isEdit" class="detail detail-color">{{ user?.mobile }}</p>
            <input
              *ngIf="isEdit"
              type="text"
              class="input detail optional"
              placeholder="{{ 'module.userProfile.myPersonalData.mobileFieldTextPlaceholder' | translate }}"
              formControlName="mobile"
              maxlength="20"
              (input)="removeUserInputSpaces('mobile')"
            />
            <span *ngIf="isEdit && this.editForm.controls.mobile.invalid && this.editForm.get('mobile')?.value !== ''" class="error-message">{{
              'module.userProfile.myPersonalData.numbersAndHyphensOnlyText' | translate
            }}</span>
          </div>
        </div>
        <div class="class profile-data-line">
          <p class="label">{{ 'module.userProfile.myPersonalData.faxNumberLabelText' | translate }}</p>
          <div class="detail">
            <p *ngIf="!isEdit" class="detail detail-color">{{ user?.fax }}</p>
            <input
              *ngIf="isEdit"
              type="text"
              class="input detail optional"
              placeholder="{{ 'module.userProfile.myPersonalData.faxFieldTextPlaceholder' | translate }}"
              formControlName="fax"
              maxlength="20"
              (input)="removeUserInputSpaces('fax')"
            />
            <span *ngIf="isEdit && this.editForm.controls.fax.invalid && this.editForm.get('fax')?.value !== ''" class="error-message">{{
              'module.userProfile.myPersonalData.numbersAndHyphensOnlyText' | translate
            }}</span>
          </div>
        </div>
      </div>

      <div class="profile-data-group" *ngIf="hasMalfunctionNotifStatusCb">
        <mat-checkbox [disabled]="!isEdit" formControlName="malFunctionNotificationStatus" class="checkbox-label">
          <span class="checkbox-label-text">
            {{ 'module.userProfile.myPersonalData.newFaultMessagesMatCheckbox' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <div class="profile-data-group" *ngIf="hasAllowToRcvWorkOrderEmailsCb">
        <mat-checkbox [disabled]="!isEdit" formControlName="allowToReceiveWorkOrderEmails" class="checkbox-label">
          <span class="checkbox-label-text">
            {{ 'module.userProfile.myPersonalData.ResolveFaultMessagesMatchCheckbox' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <div class="profile-data-group" *ngIf="isExternalUser">
        <mat-checkbox [disabled]="!isEdit" formControlName="receiveDocumentEmailStatus" class="checkbox-label">
          <span class="checkbox-label-text">
            {{ 'module.userProfile.myPersonalData.allowToReceiveDocumentEmailText' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <div class="profile-data-group">
        <mat-checkbox [disabled]="!isEdit" formControlName="allowNewsletter" class="checkbox-label">
          <span class="checkbox-label-text">
            {{ 'module.userProfile.myPersonalData.newsletterText' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <div class="button-section">
        <div *ngIf="!isEdit" class="button-group">
          <button class="btn btn-outline-primary" (click)="onEdit()">
            <span class="fa fa-pencil"></span> {{ 'module.userProfile.myPersonalData.toEditTextIcon' | translate }}
          </button>
          <button *ngIf="isCIAM()" type="button" class="btn btn-outline-primary" (click)="changePassword()">
            {{ 'module.userProfile.myPersonalData.changePasswordButtonText' | translate }}
          </button>
          <button *ngIf="!isCIAM()" type="button" class="btn btn-outline-secondary" style="cursor: not-allowed" disabled>
            {{ 'module.userProfile.myPersonalData.changePasswordButtonText' | translate }}
          </button>
        </div>

        <div *ngIf="isEdit" class="button-group">
          <button class="btn btn-outline-secondary" (click)="onCancel()">{{ 'module.userProfile.myPersonalData.abortButtonText' | translate }}</button>
          <button
            type="submit"
            class="btn btn-outline-primary -border"
            [disabled]="
              this.editForm.controls.firstname.invalid ||
              this.editForm.controls.lastname.invalid ||
              this.editForm.controls.lastname.invalid ||
              this.editForm.controls.telefon.invalid ||
              (this.editForm.get('mobile').value === '' ? !this.editForm.controls.mobile.invalid : this.editForm.controls.mobile.invalid) ||
              (this.editForm.get('fax').value === '' ? !this.editForm.controls.fax.invalid : this.editForm.controls.fax.invalid)
            "
            (click)="onSave()"
          >
            <span class="fa fa-save"></span> {{ 'module.userProfile.myPersonalData.toUpdateIconButton' | translate }}
          </button>
        </div>
      </div>
    </form>

    <div class="account-deletion" *ngIf="isCIAM()">
      <mat-divider></mat-divider>
      <div class="title">
        {{ 'module.userProfile.myPersonalData.deleteAccount.titleText' | translate }}
      </div>
      <p class="label">{{ 'module.userProfile.myPersonalData.deleteAccount.text' | translate }}</p>
      <button type="button" class="btn btn-outline-primary delete-button" (click)="deleteUserAccount()">
        {{ 'module.userProfile.myPersonalData.deleteAccount.buttonText' | translate }}
      </button>
    </div>
  </div>
</div>
